import { Row } from '@tanstack/react-table';
import { UpstreamEvent } from 'client';

import { Badge } from 'DesignSystem/ui/badge';

type Props = {
  row: Row<UpstreamEvent>;
};

export function ProductsAffected({ row }: Props) {
  const count = row.original.products_affected ?? 0;
  return <Badge variant="outline">{count}</Badge>;
}
